import React from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { FormControl, FormHelperText } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';

export default function DatePickerYear({
  name,
  label,
  value,
  error = null,
  onChange,
}) {
  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormControl variant='outlined' {...(error && { error: true })}>
        <KeyboardDatePicker
          disableToolbar
          variant='inline'
          inputVariant='outlined'
          label={label}
          style={{ width: '85%', margin: '8px' }}
          views={['year']}
          name={name}
          value={value}
          invalidDateMessage='Date incorrecte'
          onChange={(date) => onChange(convertToDefEventPara(name, date))}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </MuiPickersUtilsProvider>
  );
}
